import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Home from './pages/Home';
import Wedding from './pages/Wedding';
import Login from './pages/Login';
import './styles/global.scss';
import { applyTheme, getStoredTheme } from './utils/themes';

applyTheme(getStoredTheme());

const GMapRedirect = () => {
  window.location.replace('https://maps.app.goo.gl/uou2G5QjeMbckpuT8?g_st=ac');
  return null;
};

const ProtectedApp = () => {
  const { user } = useAuth();
  if (user === undefined) return null; // resolving auth state
  return user ? <Home /> : <Login />;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/wedding" element={<Wedding />} />
          <Route path="/gmap" element={<GMapRedirect />} />
          <Route path="/*" element={<ProtectedApp />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
